import { render, staticRenderFns } from "./ActivityApply.vue?vue&type=template&id=0dc4a584&scoped=true&"
import script from "./ActivityApply.vue?vue&type=script&lang=js&"
export * from "./ActivityApply.vue?vue&type=script&lang=js&"
import style0 from "./ActivityApply.vue?vue&type=style&index=0&id=0dc4a584&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4a584",
  null
  
)

export default component.exports